import templateUrl from '../views/modals/single-message-modal.tpl.html';
import RsvpSingleMessageModalController from '../controllers/modals/single-send/rsvp-single-message-modal';

export default function rsvpSingleMessageModalCreator($injector, rsvp, contact, extendedInformation) {
    extendedInformation = _.isObject(extendedInformation) ? extendedInformation : {};
    return $injector.get('$uibModal').open({
        controller: RsvpSingleMessageModalController,
        controllerAs: 'vm',
        size: 'xlg',
        templateUrl,
        backdrop: 'static',
        windowClass: 'modal-fixed',
        keyboard: false,
        resolve: {
            extendedInformation: () => ({
                ...extendedInformation,
                recipientModel: rsvp,
                contact
            })
        }
    }).result;
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/helpers/rsvp-single-message-modal-creator.js